//Update this function when changing cost of house call costs per half hour 
function getCostPerHourLessThanTwoHours() {
	return 80.0;
}

//Update this function when changing house call costs per hour
function getCostPerHourGreaterThanTwoHours() {
	return 75.0;
}

function setCostsText() {
	var half_hour_spans = document.getElementsByClassName("cost_less_than_two_hours");
	var cost_less_than_two_hours = getCostPerHourLessThanTwoHours();
	var cost_less_than_two_hours_per_half_hour = cost_less_than_two_hours / 2;
	var num_half_hour_spans = half_hour_spans.length;
	for(var i = 0; i < num_half_hour_spans; i++) {
		var half_hour_span = half_hour_spans[i];
		half_hour_span.innerHTML = "$" + cost_less_than_two_hours.toFixed(2) + "/hour (or $" + cost_less_than_two_hours_per_half_hour.toFixed(2) + " for every 30 minutes)";
	}

	var hour_spans = document.getElementsByClassName("cost_greater_than_two_hours");
	var cost_greater_than_two_hours = getCostPerHourGreaterThanTwoHours();
	var cost_greater_than_two_hours_per_half_hour = cost_greater_than_two_hours / 2;
	var num_hour_spans = hour_spans.length;
	for(var i = 0; i < num_hour_spans; i++) {
		var hour_span = hour_spans[i];
		hour_span.innerHTML = "$" + cost_greater_than_two_hours.toFixed(2) + "/hour (or $" + cost_greater_than_two_hours_per_half_hour.toFixed(2) + " for every 30 minutes)";
	}	
}

$(window).on("load", setCostsText);